var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-preview"},[(_vm.loading)?_c('div',{staticClass:"loading"},[_vm._v("加载中...")]):(_vm.error)?_c('div',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))]):_c('div',{domProps:{"innerHTML":_vm._s(_vm.renderedContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }